import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import {NotificationManager} from "react-notifications";

import * as AdminActions from "../../../../actions/admin"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';

class RacesInvoiceDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSuccess: PropTypes.func,
    };

    static defaultProps = {
        onSuccess: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            week: String(moment(new Date()).isoWeek()),
            clubFrom: '',
            clubTo: '299',
        }
    }

    fields = [];
    render() {
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {this.props.onClose()}}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content : {
                        height: '200px',
                        width: '500px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Fakturer til E-conomic</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields">
                                <tbody>
                                    <tr>
                                        <td><label htmlFor="week">Uge</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="week" id="week" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}"}]} value={this.state.week}
                                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              ref={instance => { this.fields[0] = instance; }}
                                            />
                                        </td>
                                        <td colSpan={2}/>
                                    </tr>
                                    <tr>
                                        <td><label htmlFor="clubFrom">Fra forening</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="clubFrom" id="clubFrom" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{3}"}]} value={this.state.clubFrom}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              onBlur={() => {
                                                                  this.fields[1].setState({focused: false, visited: true});
                                                                  if (/^[0-9]{1,2}$/.test(this.state.clubFrom)) this.setState({clubFrom: this.state.clubFrom.padStart(3, '0'), clubTo: this.state.clubTo === '' ? this.state.clubFrom.padStart(3, '0') : this.state.clubTo});
                                                                  else if (/^[0-9]{3}$/.test(this.state.clubFrom) && this.state.clubTo === '') this.setState({clubTo: this.state.clubFrom});
                                                              }}
                                                              ref={instance => { this.fields[1] = instance; }}
                                            />
                                        </td>
                                        <td><label htmlFor="clubTo">Til forening</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="clubTo" id="clubTo" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{3}"}]} value={this.state.clubTo}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              onBlur={() => {
                                                                  this.fields[2].setState({focused: false, visited: true});
                                                                  if (/^[0-9]{1,2}$/.test(this.state.clubTo)) this.setState({clubTo: this.state.clubTo.padStart(3, '0')});
                                                              }}
                                                              ref={instance => { this.fields[2] = instance; }}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-primary" onClick={this.onExport}>Fakturer</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onExport = () => {
        if (this.allInputValid()) {
            this.props.dispatch(AdminActions.invoiceRaces({
                week: Number(this.state.week),
                clubFrom: this.state.clubFrom === '' ? null : this.state.clubFrom,
                clubTo: this.state.clubTo === '' ? null : this.state.clubTo,
            }, (result) => {
                NotificationManager.success("Fakturaer er oprettet for de valgte foreninger i uge " + this.state.week + ". " + String(result.status.invoicesSend) + ' fakturaer er oprettet.' + (result.status.invoicesNotSend === 0 ? '' : ' Fakturering af ' + String(result.status.invoicesNotSend) + ' foreninger fejlede.'), "Fakturering", 4000);
                if (result.messages) result.messages.forEach(msg => {NotificationManager.warning(msg, 'Fejl', 0);});
                if (result.status.invoicesNotSend === 0) this.props.onClose();
            }))
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(RacesInvoiceDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/RacesInvoiceDialog.js